import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {YeuCauXuLy} from '../../models/yeucau/yeucauxuly';
import {catchError, map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {Message} from '../../models/danhmuc/message';
import {YeuCauComment} from '../../models/yeucau/yeucaucomment';
const apiUrl = `${environment.apiUrl}/api/info/yeucauxuly`;

@Injectable({
  providedIn: 'root'
})
export class YeuCauXuLyService {
  constructor(public httpService: HttpClient) { }
  public getAll(): Observable<YeuCauXuLy[]> {
    return this.httpService.get<YeuCauXuLy[]>(`${apiUrl}/getall`).pipe(
      map(data => data.map(data => new YeuCauXuLy().deserialize(data)))
    );
  }
  public add(params: Object): Observable<YeuCauXuLy>
  {
    return this.httpService.post(`${apiUrl}/add`, params).pipe(
      map(data => new YeuCauXuLy().deserialize(data)));

  }
  public update(params: Object): Observable<YeuCauXuLy>
  {
    return this.httpService.post(`${apiUrl}/update`, params).pipe(
      map(data => new YeuCauXuLy().deserialize(data)));

  }
  public getCountByKeyword(keyword: string , status: String, staffId: number, xem: number, fromDate: string, toDate: string)
  {
    return this.httpService.get(`${apiUrl}/getcountbykeyword?keyword=${keyword}&status=${status}&staffid=${staffId}&xem=${xem}&frdate=${fromDate}&todate=${toDate}`).pipe(
      map(data => Number(data)));
  }
  public getCountByKeyword2(keyword: string , status: String, staffId: number, xem: number, fromDate: string, toDate: string, typeSearch: number)
  {
    return this.httpService.get(`${apiUrl}/getcountbykeyword2?keyword=${keyword}&status=${status}&staffid=${staffId}&xem=${xem}&frdate=${fromDate}&todate=${toDate}&stype=${typeSearch}`).pipe(
      map(data => Number(data)));
  }
  public getById(id: number): Observable<YeuCauXuLy>
  {
    return this.httpService.get<YeuCauXuLy>(`${apiUrl}/findbyid/${id}`).pipe(
      map(data => new YeuCauXuLy().deserialize(data)),
      catchError(() => throwError('items not found'))
    );
  }
  public delete(id: number): Observable<Message>
  {
    return this.httpService.get<Message>(`${apiUrl}/delete/${id}`).pipe(
      map(data => new Message().deserialize(data)),
      catchError(() => throwError('id delete not found'))
    );
  }
  findByKeyword(keyword: String): Observable<YeuCauXuLy[]> {
    return this.httpService.get<YeuCauXuLy[]>(`${apiUrl}/findbykeyword?keyword=${keyword}`).pipe(
      map(data => data.map(data => new YeuCauXuLy().deserialize(data)))
    );
  }
  findAllByPaging(keyword: String, status: String, staffId: number, xem: number, fromDate: string, toDate: string, page: number, size: number): Observable<YeuCauXuLy[]> {
    return this.httpService.get<YeuCauXuLy[]>(`${apiUrl}/getallpaging?key=${keyword}&status=${status}&staffid=${staffId}&xem=${xem}&frdate=${fromDate}&todate=${toDate}&page=${page}&size=${size}`).pipe(
      map(data => data.map(data => new YeuCauXuLy().deserialize(data)))
    );
  }
  findAllByPaging2(keyword: String, status: String, staffId: number, xem: number, fromDate: string, toDate: string, page: number, size: number, typeSearch: number): Observable<YeuCauXuLy[]> {
    return this.httpService.get<YeuCauXuLy[]>(`${apiUrl}/getallpaging3?key=${keyword}&status=${status}&staffid=${staffId}&xem=${xem}&frdate=${fromDate}&todate=${toDate}&page=${page}&size=${size}&stype=${typeSearch}`).pipe(
      map(data => data.map(data => new YeuCauXuLy().deserialize(data)))
    );
  }

  findByMaYeuCau(id: number): Observable<YeuCauXuLy[]> {
    return this.httpService.get<YeuCauXuLy[]>(`${apiUrl}/findallbymayeucau/${id}`).pipe(
      map(data => data.map(data => new YeuCauXuLy().deserialize(data)))
    );
  }
  public chenHoSo(id: number, hoSoId: number): Observable<Message>
  {
    return this.httpService.get<Message>(`${apiUrl}/chenhoso?id=${id}&hsid=${hoSoId}`).pipe(
      map(data => new Message().deserialize(data)),
      catchError(() => throwError('id insert not found'))
    );
  }

  public changeStatus(id: number, status: number, staffId: number): Observable<Number>
  {
    return this.httpService.get(`${apiUrl}/changestatus/${id}?st=${status}&uid=${staffId}`).pipe(
      map(data => Number(data)),
      catchError(() => throwError('items not found'))
    );
  }
  public updateXuLy(params: Object): Observable<number>
  {
    return this.httpService.post(`${apiUrl}/updatexuly`, params).pipe(
      map(data => Number(data)));

  }
  public changeView(id: number,  staffId: number): Observable<Number>
  {
    return this.httpService.get(`${apiUrl}/changeview/${id}?uid=${staffId}`).pipe(
      map(data => Number(data)),
      catchError(() => throwError('items not found'))
    );
  }
  findAllCommentByMaVB(id: number): Observable<YeuCauComment[]> {
    return this.httpService.get<YeuCauComment[]>(`${apiUrl}/getallcommentbymvb?id=${id}`).pipe(
      map(data => data.map(data => new YeuCauComment().deserialize(data)))
    );
  }
  public getByMaVBAndMXL(id: number, staffId: number): Observable<YeuCauXuLy>
  {
    return this.httpService.get<YeuCauXuLy>(`${apiUrl}/getbymavbandmaxl/${id}?uid=${staffId}`).pipe(
      map(data => new YeuCauXuLy().deserialize(data)),
      catchError((error: HttpErrorResponse) => throwError(error.message))
    );
  }
  public xuLyLai(id: number, status: number,  nguoiChuTriId: number)
  {
    return this.httpService.get(`${apiUrl}/xulylai?id=${id}&st=${status}`
      +`&uid=${nguoiChuTriId}`).pipe(
      map(data => Number(data)));
  }
}
